import React from "react";

export function UserTabList({ activeTab, setActiveTab, children }) {
    return (
        <div className="user-tabs">
            {React.Children.toArray(children).map((child, index) =>
                React.isValidElement(child) ? React.cloneElement(child, { index, activeTab, setActiveTab }) : null
            )}
        </div>
    );
}

export function UserTab({ children, index, activeTab, setActiveTab }) {
    const isActive = activeTab === index;

    return (
        <div onClick={() => setActiveTab(index)} className={`user-tab-select ${isActive ? "active" : ""}`}>
            {children}
        </div>
    );
}

export function UserTabPanels({ activeTab, children }) {
    return <div className="user-tab-content">{children[activeTab]}</div>;
}

export function UserTabPanel({ children }) {
    return <div>{children}</div>;
}
